export default "__VITE_ASSET__DS22TcvP__"